<template>
  <div>
    <el-dialog
      :visible="systemDialog"
      @close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="modal-box">
        <div class="modal-head">
          系统决策建议
        </div>
        <div :class=color(msg.systemResult)>
          <div class="finally-head">故障系统决策：<span>{{msg.systemResultComment}}</span></div>
          <div class="finally-box">
            <div class="finally-h">基于以下原因作出判断:</div>
            <div class="finally-p" v-for="item in msg.systemHints" :value="item">{{item}}</div>
          </div>
        </div>
        <div class="redecision-bt-box">
          <div class="redecision-bt" @click="deny">不同意并重新决策</div>
          <div class="redecision-bt active" @click="agree">同意并采纳</div>
        </div>
      </div>
    </el-dialog>
    <redecision v-if="redecisionDialog" :red="redecisionDialog" @handle-close="closeRedecision" :id="msg.id"/>
  </div>
</template>

<script>
import redecision from "@/components/redecision";
import {socAgree} from '@/api/api'

  export default {
    name: "",
    components: {redecision},
    props: {
      systemDialog: {
        default: false,
        textarea: ''
      },
      msg: {
        type: Object
      }
    },
    data() {
      return {
        radio: 3,
        redecisionDialog: false
      };
    },
    methods: {
      handleClose() {
        this.$emit('handle-close')
      },
      color(result) {
        return `redecision-box ${result === "R1" ? '' : 'active'}`
      },
      deny() {
        this.redecisionDialog=true
      },
      closeRedecision(all){
        this.redecisionDialog=false
        if (all){
          this.handleClose()
        }
      },
      async agree(){
        const res = await socAgree(this.msg.id)
        if (res.code === 'A00000'){
          this.$message.success('决策成功')
          this.handleClose()
        }else {
          this.$message.error(res.message)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .finally-head {
    font-size: 18px;

    span {
      color: #8EBF86;
    }
  }

  .finally-box {
    background: #393F52;
    border-radius: 8px;
    padding: 16px;
    margin-top: 24px;

    .finally-h {
      color: rgba(255, 255, 255, 0.6) !important;
      /*color: #8EBF86;*/
      font-size: 16px;
    }

    .finally-p {
      color: #fff;
      /*color: rgba(255, 255, 255, 0.6);*/
      font-size: 16px;
      margin-top: 12px;
      display: flex;
      align-items: center;
    }
    .finally-p::before{
      content: '';
      display: block;
      width: 5px;
      height: 5px;
      background: #8EBF86;
      border-radius: 50%;
      margin-right: 8px;
      margin-top: 2px;
    }
  }

  .modal-head {
    font-size: 18px;
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .redecision-box.active {
    .finally-head {
      span {
        color: #E07073;
      }
    }
    .finally-p::before{
      content: '';
      display: block;
      width: 5px;
      height: 5px;
      background: #E07073;
      border-radius: 50%;
      margin-right: 8px;
      margin-top: 2px;
    }
    .finally-box {
      .finally-h {
        color: #E07073;
      }
    }
  }

  .redecision-box {
    padding: 24px;
    text-align: left;
  }

  .redecision-bt-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 24px;

    .redecision-bt {
      height: 44px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      border-radius: 8px;
      width: 268px;
      margin-right: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .redecision-bt.active {
      height: 44px;
      border: 1px solid #2769EC;
      background: #2769EC;
      border-radius: 8px;
      width: 268px;
      margin-right: 0;
      flex: 1;
    }
  }

  /deep/ .el-dialog {
    background: #262D40;
    padding-bottom: 24px;
    width: 600px;
    border-radius: 12px;

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 0;
      color: #fff;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 20px;
    }

    .el-dialog__headerbtn {
      top: 23px;
    }

    .el-textarea {
      width: 390px;
    }

    .el-textarea textarea {
      height: 168px;
      background: #393F52;
      border-radius: 8px;
      margin: 0;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/system.vue